module.exports = __webpack_public_path__ + "img/new_tg.4e4f9182.jpg";